import {Injectable} from "@angular/core";
import {FuseMockApiService} from "../../../core/mock-api";
import {
  SS_COUPONS_VALIDATE_ENDPOINT,
  SsResult,
  SsResultStatusCode
} from "../../../features/stockstore-pos/stockstore-pos.types";
import {CouponValidationRequest, CouponValidationResponse} from "../../../features/coupons/coupons.types";
import {CouponsTestData} from "./data";

@Injectable({
  providedIn: 'root'
})
export class CouponsMockApi {

  constructor(private _fuseMockApiService: FuseMockApiService) {
    this.registerHandlers();
  }

  /**
   * Register Mock API handlers
   */
  registerHandlers(): void {

    // -----------------------------------------------------------------------------------------------------
    // @ Coupon Validation POST: Handles mock of SS coupon validation API
    // -----------------------------------------------------------------------------------------------------
    this._fuseMockApiService
      .onPost("http://127.0.0.1:1221/" + SS_COUPONS_VALIDATE_ENDPOINT, 1000)
      .reply((request) => {

        const validationRequest: CouponValidationRequest = request.request.body;
        const couponCode = validationRequest.couponCode?.toUpperCase();

        console.log('Mock API: Validating coupon:', couponCode);
        console.log('Mock API: Active coupons:', validationRequest.activeCoupons);

        // Search for coupon in test data
        const mockCoupon = CouponsTestData.find(c => c.code === couponCode);

        if (mockCoupon) {
          // Coupon found in test data
          const statusCode = mockCoupon.statusCode;

          const result: SsResult<CouponValidationResponse> = {
            isSuccess: statusCode === SsResultStatusCode.OK || statusCode === SsResultStatusCode.OK_COUPON_ARTICLE_PROMO,
            errorMessages: [],
            statusCode: statusCode.toString(),
            result: mockCoupon.response
          };

          console.log('Mock API: Returning response:', result);
          return [200, result];

        } else {
          const result: SsResult<CouponValidationResponse> = {
            isSuccess: false,
            errorMessages: [],
            statusCode: SsResultStatusCode.ERR_COUPON_NOT_FOUND,
            result: {}
          };

          console.log('Mock API: Coupon not found, returning default error:', result);
          return [200, result];
        }
      });
  }
}
